module.exports = __webpack_public_path__ + "static/media/BlueSkysummercamplogo2006.8bb24387.webp";